var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVkMobileViews = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 12,
  viewBox: "0 0 17 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M8.5 12C3.4 12 0 7.2 0 6s3.4-6 8.5-6S17 4.8 17 6s-3.4 6-8.5 6m0-1.8c2.307 0 4.25-1.92 4.25-4.2S10.807 1.8 8.5 1.8 4.25 3.72 4.25 6s1.943 4.2 4.25 4.2m0-2.28c-1.093 0-1.943-.84-1.943-1.92s.85-1.92 1.943-1.92 1.943.84 1.943 1.92-.85 1.92-1.943 1.92"
})));
export default SvgVkMobileViews;